<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <v-flex xs12 sm6 md6>
          <v-btn color="primary" @click="is_agaza = true">اضافة اجازة </v-btn>
          <v-btn color="red" @click="is_absence = true">اضافة غياب </v-btn>

          <br />
          <br />
          <br />
          <br />
          <v-btn color="orange" @click="get_table"
            >أختر الشهر ثم اضغط لمعرفة تفاصيل الاجازات والغياب خلال هذا الشهر
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 md6>
          <v-date-picker
            v-model="picker"
            landscape
            type="month"
            color="green lighten-1"
          ></v-date-picker>
        </v-flex>
        <v-spacer></v-spacer>

        <!-- <v-flex xs12 sm6 md2>
        <v-dialog
          ref="dialog_from"
          v-model="modal_from"
          :return-value.sync="date_from"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_from"
              label="تاريخ من"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_from" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_from = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_from.save(date_from)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex>
             <v-flex xs12 sm6 md2>
                  <v-dialog
          ref="dialog_to"
          v-model="modal_to"
          :return-value.sync="date_to"
          persistent
          lazy
          full-width
          width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              v-model="date_to"
              label="تاريخ الي"
              prepend-icon="event"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker v-model="date_to" scrollable>
            <v-spacer></v-spacer>
            <v-btn flat color="primary" @click="modal_to = false">Cancel</v-btn>
            <v-btn flat color="primary" @click="$refs.dialog_to.save(date_to)">OK</v-btn>
          </v-date-picker>
        </v-dialog>
             </v-flex> -->
        <v-dialog v-model="is_agaza" max-width="500px" dir="rtl" align="right">
          <v-card>
            <v-card-title>
              <span class="headline">اضافة اجازة</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-autocomplete
                        v-model="select_employer_agaza"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      >
                        <template v-slot:append-outer>
                          <v-slide-x-reverse-transition mode="out-in">
                          </v-slide-x-reverse-transition>
                        </template>
                      </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_vacancy"
                        :items="vacancy_types"
                        item-text="name"
                        item-value="id"
                        label="أختر نوغ الاجازة"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="agaza"
                        label=" الاجازة"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_agaza()"
                >اضافة اجازة</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog
          v-model="is_absence"
          max-width="500px"
          dir="rtl"
          align="right"
        >
          <v-card>
            <v-card-title>
              <span class="headline">اضافة غياب</span>
            </v-card-title>

            <v-card-text>
              <v-form ref="form">
                <v-container grid-list-md>
                  <v-layout wrap>
                    <v-flex xs12 sm6 md4>
                      <v-select
                        v-model="select_employer_absence"
                        :items="employers"
                        item-text="name"
                        item-value="id"
                        label="أختر الموظف"
                        persistent-hint
                        return-object
                        single-line
                        v-validate="'required'"
                        :error-messages="errors.collect('form1.manger')"
                        data-vv-name="manger"
                        data-vv-scope="form1"
                      ></v-select>
                    </v-flex>

                    <v-flex xs12 sm6 md4>
                      <v-text-field
                        v-model="absance"
                        label=" الغياب"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click="close">الغاء</v-btn>
              <v-btn color="blue darken-1" flat @click.native="add_absence()"
                >اضافة الغياب</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>

      <v-data-table
        :headers="headers"
        :items="fatworas"
        class="elevation-1"
        v-if="fatworas.length > 0"
        :rows-per-page-items="rowsPerPageItems"
      >
        <template slot="items" slot-scope="props">
          <td>{{ props.item.code }}</td>
          <td>{{ props.item.name }}</td>
          <td>{{ props.item.job }}</td>
          <td><p v-html="props.item.tot_agaza"></p></td>
          <td>{{ props.item.tot_agaza_count }}</td>
          <td><p v-html="props.item.tot_abscence"></p></td>
          <td>{{ props.item.tot_abscence_count }}</td>
        </template>
      </v-data-table>
      <div v-else>لا يوجد فواتير</div>
    </v-container>
  </div>
</template>

<script>
import {
  items,
  search_client_by_code,
  madionia_client,
  fatworas_client_no_sadad,
  branches,
  khazina,
  employers_vacation,
  employers,
  khazna_fatworas,
  add_agaza,
  add_absence
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    rowsPerPageItems: [400, 800],
    date_from: new Date().toISOString().substr(0, 10),
    date_to: new Date().toISOString().substr(0, 10),
    picker: new Date().toISOString().substr(0, 7),
    month: "",
    year: "",
    menu_from: false,
    modal_from: false,
    menu_to: false,
    modal_to: false,
    menu2: false,
    detail_dialog: false,
    add_dialog: false,
    edit_dialog: false,
    vacancy_types: [
      { id: 1, name: "مرض" },
      { id: 2, name: "اعتيادي" },
      { id: 3, name: "عارضة" }
    ],
    headers: [
      {
        text: " كود الموظف",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " اسم الموظف",
        align: "right",
        value: "name",
        sortable: false
      },
      {
        text: " الوظيفة",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الاجازات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " عدد الاجازات ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " الغياب ",
        value: "address",
        sortable: false,
        align: "right"
      },
      {
        text: " عدد الغياب ",
        value: "address",
        sortable: false,
        align: "right"
      }
    ],
    active: "",
    select_employer_agaza: { id: "" },
    select_employer_absence: { id: "" },
    select_vacancy: { id: "" },
    search: "",
    comment: "",
    loading: true,
    agaza: "",
    absance: "",
    badalat: "",
    solfa: "",
    is_agaza: false,
    is_absence: false,
    is_badalat: false,
    is_solfa: false,
    khazina_fatworas: [],
    items: [],
    employers: [],
    fatworas: [],
    branches: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theKhazna: {},
    item_detail: {},
    all_of_total: 0,
    count_of_count: 0,
    madionia_sabqa_of_madionia: "",
    madionia_sabqa: ""
  }),

  computed: {
    mycode() {
      if (this.khazina_fatworas.length > 0) {
        return (this.code =
          parseInt(
            this.khazina_fatworas[this.khazina_fatworas.length - 1].code
          ) + 1);
      } else {
        return (this.code = 1000);
      }
    },
    omola_percentage() {
      return function(total, omola) {
        return (parseFloat(total) * parseFloat(omola)) / 100;
      };
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      branches().then(response => {
        this.branches = response.data;
        this.loading = false;
      });

      khazna_fatworas().then(response => {
        this.khazina_fatworas = response.data;
      });

      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      employers_vacation(frmData).then(response => {
        this.fatworas = response.data;
      });
      employers().then(response => {
        this.employers = response.data;
      });

      items().then(response => {
        this.items = response.data;
      });
    },
    search_client_by_code() {
      search_client_by_code(this.searchClientCode).then(response => {
        this.select_item = response.data;
        this.get_all_info();
      });
    },
    get_all_info() {
      this.searchClientCode = this.select_item.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_item.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_item.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? parseFloat(response.data.client.rasid_efttahi)
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_khazina() {
      khazina(this.select_branch.id).then(response => {
        this.theKhazna = response.data;
      });
    },
    detailItem(order) {
      this.item_detail = order;
    },
    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    get_table() {
      this.month = this.picker.substr(5, 2);
      this.year = this.picker.substr(0, 4);
      var frmData = new FormData();
      frmData.append("month", this.month);
      frmData.append("year", this.year);
      employers_vacation(frmData).then(response => {
        this.fatworas = response.data;
      });
    },
    add_agaza() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_agaza.id);
      frmData.append("vacancy_type", this.select_vacancy.name);
      frmData.append("agaza", this.agaza);

      if (
        this.select_employer_agaza.id != "" &&
        this.agaza != "" &&
        this.select_vacancy.id != ""
      ) {
        add_agaza(frmData).then(response => {
          this.$router.go(0);
        });
      }
    },
    add_absence() {
      var frmData = new FormData();
      let month = new Date().toISOString().substr(5, 2);
      let year = new Date().toISOString().substr(0, 4);
      frmData.append("employer_id", this.select_employer_absence.id);
      frmData.append("absance", this.absance);
      if (this.select_employer_absence.id != "" && this.absance != "") {
        add_absence(frmData).then(response => {
          this.$router.go(0);
        });
      }
    }
  }
};
</script>

<style scoped>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
.v-date-picker-table--month td {
  height: 35px;
}
.v-picker__body {
  height: 196px;
}
.v-table__overflow {
  width: 1000px;
  margin-right: -85px;
}
</style>
